import moment from "moment";
import HelperMixin from "../../../Shared/HelperMixin.vue";

export default {
    name: "SubscriptionsOverview",
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
    },

    filters: {
        moment: function (date) {
            if (!date) return "—";
            return moment(date).format("DD/MM/YYYY");
        }
    },

    data() {
        return {
            ScreenTitle: "نظرة عامة - الاشتراكات",

            // KPIs
            ActiveCount: 0,
            Mrr: 0,
            ExpiringCount: 0,

            // Lists
            ExpiringSoon: [],
            ByPlanType: [],
            ByStatus: []
        };
    },

    computed: {
        ByPlanTypeMax() {
            // Largest count, used for the bar fill ratio (avoid divide-by-zero).
            let max = 0;
            for (let i = 0; i < this.ByPlanType.length; i++) {
                const c = Number(this.ByPlanType[i].count) || 0;
                if (c > max) max = c;
            }
            return max || 1;
        }
    },

    methods: {
        GetInfo() {
            this.$blockUI.Start();

            this.$http
                .GetSubscriptionsDashboard()
                .then((response) => {
                    this.$blockUI.Stop();

                    const data = response.data || {};

                    this.ActiveCount = data.activeCount ?? 0;
                    this.Mrr = data.mrr ?? 0;
                    this.ExpiringCount = data.expiringCount ?? 0;

                    this.ExpiringSoon = data.expiringSoon || [];
                    this.ByPlanType = data.byPlanType || [];
                    this.ByStatus = data.byStatus || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();

                    this.ActiveCount = 0;
                    this.Mrr = 0;
                    this.ExpiringCount = 0;
                    this.ExpiringSoon = [];
                    this.ByPlanType = [];
                    this.ByStatus = [];
                });
        },

        StatusLabel(status) {
            switch (Number(status)) {
                case 1: return "نشط";
                case 2: return "منتهي";
                case 3: return "موقوف";
                case 4: return "خارج الخدمة";
                case 9: return "محذوف";
                default: return "—";
            }
        },

        PlanBarWidth(count) {
            const c = Number(count) || 0;
            const pct = Math.round((c / this.ByPlanTypeMax) * 100);
            return Math.max(pct, 4) + "%";
        },

        Refresh() {
            this.GetInfo();
        }
    }
};
